import { RouterProvider } from "react-router-dom";

import { router } from "./routers";
import Loading from "./components/loading";

export default function App() {
  return <RouterProvider router={router} fallbackElement={<Loading />} />;
}
